export default __webpack_public_path__ + "static/media/categna.b79c020d.jpg";